{
	"nav": {
		"about": "About",
		"projects": "Projects",
		"contact": "Contact",
		"blog": "Blog"
	},
	"banner": {
		"name": "Francesco Anzalone",
		"title": "Full Stack Software Engineer",
		"badges": {
			"tools": "Creator of Developer Tools",
			"ai": "AI-Enhanced Development",
			"enterprise": "Enterprise Solutions"
		},
		"cta": {
			"projects": "View projects",
			"contact": "Contact me"
		}
	},
	"about": {
		"title": "About me",
		"text": [
			"I build web applications that solve real business problems.",
			"For the past four years I've been re-engineering a legacy B2B platform used by major European tour operators, taking an IE-only codebase to a modern front end without interrupting the business that runs on it.",
			"As a freelance developer I designed and delivered a recruitment platform end to end: Next.js front end, serverless Node.js back end, PDF generation, transactional email and a CI/CD pipeline, without storing any candidate data. One developer, about three months.",
			"On the side I've published four VS Code extensions with over 16,000 installs, all born from real workflow problems. I also work daily with AI development tools (Claude Code, GitHub Copilot) to ship better code, faster.",
			"Based in the UK, available for remote or hybrid roles with enterprise software teams."
		]
	},
	"projects": {
		"header": "Projects"
	},
	"services": {
		"title": "Services & expertise",
		"items": [
			{
				"title": "Full-Stack Development",
				"description": "Building scalable web applications with modern frameworks (React, Angular, Vue.js) and robust backend systems (Node.js, TypeScript)"
			},
			{
				"title": "B2B Platform Engineering",
				"description": "Re-engineering legacy systems and developing enterprise-grade solutions for complex business requirements"
			},
			{
				"title": "Developer Tools & Productivity",
				"description": "Creating VS Code extensions and automation tools that improve team efficiency and workflow optimization"
			},
			{
				"title": "AI-Powered Development",
				"description": "Using AI tools (GitHub Copilot, Claude Code, Codex) daily to accelerate delivery and improve code quality"
			}
		]
	},
	"techStack": {
		"title": "Tech stack",
		"categories": {
			"frontend": {
				"title": "Frontend",
				"technologies": ["React", "Next.js", "Angular", "Vue.js", "TypeScript", "JavaScript", "HTML5", "CSS3", "SASS", "Tailwind CSS"]
			},
			"backend": {
				"title": "Backend",
				"technologies": ["Node.js", "Express", "REST APIs", "GraphQL"]
			},
			"devops": {
				"title": "DevOps & Tools",
				"technologies": ["Git", "GitHub Actions", "Docker", "CI/CD", "Webpack", "Parcel", "npm"]
			},
			"other": {
				"title": "Other",
				"technologies": ["VS Code Extension API", "Redux", "RxJS", "Jest", "Vitest", "Playwright", "Agile/Scrum"]
			}
		}
	},
	"extensions": {
		"title": "Published VS Code extensions",
		"subtitle": "Developer productivity tools used by thousands worldwide",
		"stats": {
			"downloads": "Installs",
			"openSource": "Open Source",
			"rating": "Average Rating",
			"extensions": "Published Extensions"
		},
		"cta": "View on Marketplace"
	},
	"contact": {
		"title": "Contact me",
		"direct": "Prefer email? Reach me directly:",
		"form": {
			"name": "Your Name",
			"email": "Email",
			"message": "Message",
			"send": "Send"
		}
	}
}
